import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-occasion-rewards',
  templateUrl: './occasion-rewards.component.html',
  styleUrls: ['./occasion-rewards.component.scss']
})
export class OccasionRewardsComponent extends FeaturesBaseComponent implements OnInit {

  constructor() {
    super()
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
